import { type MutableRefObject, useRef } from 'react';

const empty = Symbol('empty');

export function useCallbackRef<GetInitValue>(getInitValue: () => GetInitValue): MutableRefObject<GetInitValue> {
  const ref = useRef<symbol | GetInitValue>(empty);

  if (ref.current === empty) {
    ref.current = getInitValue();
  }

  return ref as MutableRefObject<GetInitValue>;
}
